import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
}

const sizeMap = {
  sm: "w-4 h-4 border-2",
  md: "w-8 h-8 border-4",
  lg: "w-12 h-12 border-4",
};

export function LoadingSpinner({ size = "md", className, label = "Carregando" }: LoadingSpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(
        "border-primary border-t-transparent rounded-full animate-spin",
        sizeMap[size],
        className
      )}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}
